// extracted by mini-css-extract-plugin
module.exports = {"form":"signup-cpf-form_form__wYLl8","agreementLink":"signup-cpf-form_agreementLink__q_me6","agreementText":"signup-cpf-form_agreementText__tqwYC"};